import { render, staticRenderFns } from "./BrandProductivityReport.vue?vue&type=template&id=010ae4af&scoped=true&"
import script from "./BrandProductivityReport.vue?vue&type=script&lang=js&"
export * from "./BrandProductivityReport.vue?vue&type=script&lang=js&"
import style0 from "./BrandProductivityReport.scss?vue&type=style&index=0&id=010ae4af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ae4af",
  null
  
)

export default component.exports